import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import AuthUtility from "../../util/AuthUtility";
import { Col, Button, Row, Container, Card, Form, Table,Tabs, Tab, Modal, Carousel, Badge} from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import toast, { Toaster } from 'react-hot-toast';
import { onProductDetail } from "../../controller/ProductController";
import { ProductDetailEntity } from "../../dto/product/ProductDetailEntity";

type ProductParams = {
    productId: string;
};

const ProductDetail = () => {
  const navigate = useNavigate();
  const { productId } = useParams<ProductParams>();
  const [detail, setDetail] = useState<ProductDetailEntity>({});

  // first render
  useEffect(() => {
    if (!AuthUtility.isUserLoggedIn()) {
        navigate("/login");
        window.location.reload();
    } else {
        productDetailGet();
    }
  }, [])

  const productDetailGet = async () => {
    const response = await onProductDetail(parseInt(productId!));
    const data = response.data;
    if (data !== undefined) {
      setDetail({
          product: data.product
              ? {
                  ...data.product,
                  createdAt: data.product.createdAt
                  ? new Date(data.product.createdAt)
                  : undefined,
                  updatedAt: data.product.updatedAt
                  ? new Date(data.product.updatedAt)
                  : undefined,
              }
              : undefined,
      
          medias: data.medias?.map((m) => ({
              ...m,
              preview: 'https://ns9.checkin.mn/v1/file/api/files/' + m.fileUuid,
              createdAt: m.createdAt ? new Date(m.createdAt) : undefined,
              updatedAt: m.updatedAt ? new Date(m.updatedAt) : undefined,
          })),
      
          attributes: data.attributes
      });
    }
  }

  const [attributeSearch, setAttributeSearch] = useState("");

  const filteredAttributes = (detail?.attributes || []).filter(a => {
    const attrName = a.attribute?.name?.toLowerCase() || "";
    const valueText = a.attributeChoice?.valueText?.toLowerCase() || "";
  
    const keyword = attributeSearch.toLowerCase();
  
    return (
      attrName.includes(keyword) ||
      valueText.includes(keyword)
    );
  });

  return (
    <Container fluid>
      <div><Toaster position="top-right" reverseOrder={false}/></div>
      <h3><a onClick={() => navigate(-1)}><big>&#8592;</big></a>Product Detail</h3>
      <Card className="mb-3">
        <Card.Header>Basic Information</Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Title</Form.Label>
                <Form.Control value={detail.product?.title || ""} readOnly />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Description</Form.Label>
                <Form.Control value={detail.product?.description ?? ""} readOnly />
              </Form.Group>
              <div>Created At: {detail.product?.createdAt?.toLocaleDateString() || '-'}</div>
              <div>Updated At: {detail.product?.updatedAt?.toLocaleDateString() || '-'}</div>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Status</Form.Label>
                <Form.Control value={detail.product?.status || ""} readOnly />
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ============ MEDIA ============ */}
      <Card className="mb-3">
        <Card.Header className="d-flex justify-content-between">
          <span>Product Media ({detail?.medias?.length || 0})</span>
        </Card.Header>
        <Card.Body>
          <Table bordered hover>
            <thead>
              <tr>
                <th>Preview</th>
                <th>Sort Order</th>
                <th>Status</th>
                <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              {detail?.medias?.map(m => (
                <tr key={m.id}>
                  <td><img src={m.preview} alt={m.sortOrder + ''} width={80} /></td>
                  <td>{m.sortOrder}</td>
                  <td><Badge bg={m.status === 'ACTIVE' ? 'success' : 'secondary'}>{m.status}</Badge></td>
                  <td>{m.createdAt?.toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      {/* ============ ATTRIBUTES ============ */}
      <Card className="mb-3">
        <Card.Header className="d-flex justify-content-between">
          <span>Attributes ({detail?.attributes?.length || 0})</span>
        </Card.Header>
        <Card.Body>
          <Form.Control
            type="text"
            placeholder="Search attributes..."
            className="mb-3"
            value={attributeSearch}
            onChange={(e) => setAttributeSearch(e.target.value)}
          />
          <Table bordered hover>
            <thead>
              <tr>
                <th>Attribute</th>
                <th>Choice</th>
              </tr>
            </thead>
            <tbody>
              {filteredAttributes.map(a => (
                <React.Fragment key={a.attributeChoiceId}>
                  <tr>
                    <td>{a.attribute?.name}</td>
                    <td>{a.attributeChoice?.valueText}</td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

    </Container>
  )
}

export default ProductDetail;